module.exports={
"type": "FeatureCollection",
"name": "bounding_box_wgs84",
"crs": { "type": "name", "properties": { "name": "urn:ogc:def:crs:OGC:1.3:CRS84" } },
"features": [
{
	"type":"Feature",
	"geometry": {
		"type": "Point",
		"coordinates": [ -92.232254741170564, 13.72930666560671 ]
	}
},
{
	"type":"Feature",
	"geometry": {
		"type": "Point",
		"coordinates": [ -88.241023349878972, 13.729429875538147 ]
	}
},
{
	"type":"Feature",
	"geometry": {
		"type": "Point",
		"coordinates": [ -88.200803575466651, 17.808855795958966 ]
	}
},
{
	"type":"Feature",
	"geometry": {
		"type": "Point",
		"coordinates": [ -92.272742983103228, 17.80873014520208 ]
	}
}
]
}